import { render, staticRenderFns } from "./putLinkLd.vue?vue&type=template&id=0d74f7bc&scoped=true"
import script from "./putLinkLd.vue?vue&type=script&lang=js"
export * from "./putLinkLd.vue?vue&type=script&lang=js"
import style0 from "./putLinkLd.vue?vue&type=style&index=0&id=0d74f7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74f7bc",
  null
  
)

export default component.exports